import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FeedbackMaster } from 'src/app/models/feedback-master';
import { FeedbackMultiple } from 'src/app/models/feedback-multiple';
import { RequestApiService } from 'src/app/services/domain_code/request-api.service';
import { FeedbackMasterApiService } from 'src/app/services/feedback-master-api.service';

@Component({
  selector: 'logzy-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss']
})
export class FeedbackComponent implements OnInit {
  feedbackQuestions: any;
  confirmationMessage: string;
  placeholder: string;
  current_feedback_index: number;
  feedbackResponse: any;
  feedback_items: any;
  @Input() feedbackQuestion = [];
  @Output() feedbackSubmited = new EventEmitter<boolean>();
  @Output() feedbacksubmit1 = new EventEmitter<any>();
  @Output() feedbackCheck = new EventEmitter<any>();
  askComment(index) {
    this.current_feedback_index = index;

  }
  feedbackSubmit() {
    this.feedbackSubmited.emit(true);
  }
  feedbackObject: FeedbackMaster = {
    id: null,
    is_active: true,
    value: null,
    sequence_no: null,
    dev_value: null,
    is_internal: null,
    is_positive: null
  }

  multipleFeedbackObject: FeedbackMultiple = {
    id: null,
    is_active: true,
    remarks: null,
    rating: null,
    request: null,
    parameter: null
  }
  constructor(private feedbackService: FeedbackMasterApiService, public requestService: RequestApiService, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      if ('id' in params) {
        this.getFeedback(params['id']);
        this.getFeedbackByReqId(params['id']);
      }
    });

  }
  //Get Feedback for requirements
  getFeedback(id) {
    this.feedbackService.getFeedback(id).subscribe({
      next: response => {
        this.feedback_items = response.results.map(item => {
          return {
            parameter: item.id,
            question: item.value,
            request: id,
            rating: null,
            remarks: '',
          }
        });
        console.log("Feedback Response", this.feedback_items);
        this.feedbackCheck.emit(this.feedback_items);
      },
      error: error => {
        console.log(error)
        return error;
      }
    });
  }
  //Post Feedback with request Id
  postfeedbackSubmit() {
    let data = this.feedback_items[this.current_feedback_index];
    // this.multipleFeedbackObject.request = this.requestService.selectedRequest.id;
    // this.feedbackService.postFeedback(this.feedback_items,this.requestService.selectedRequest.id).subscribe({
    this.feedbackService.postFeedback(this.feedback_items).subscribe({
      next: response => {
        this.getFeedbackByReqId(this.requestService.selectedRequest.id)
        this.feedbacksubmit1.emit(response);
        this.feedbackSubmited.emit(true);
        // this.feedbackQuestions = response;
        this.confirmationMessage = "Thanks for sharing your valuable feedback.";
      },
      error: error => {
        console.log(error)
        return error;
      }
    });
  }

  getFeedbackByReqId(id) {
    this.feedbackService.getFeedbackbyReqID(id).subscribe({
      next: response => {
        this.feedbackResponse = response.results;

      },
    })
  }

  skipFeedback() {
    this.feedbackSubmited.emit(true);
  }

  set_rating(rating, index) {
    this.current_feedback_index = index;
    this.feedback_items[index].rating = rating;
    switch (index) {
      case 0:
        this.placeholder = "This is really not acceptable. We are all ears to hear your grievance to improve and do better the next time.";
        break;
      case 1:
        this.placeholder = "We take such feedback very seriously. Please share your feedback to do this better next time."
        break;
      case 2:
        this.placeholder = "Let us know how can we improve to make it better the next time."
        break;

      default:
        break;
    }

  }
}
